import React, { Component } from 'react';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import TableParent from '../commonComponents/TableParent';
import CallAPI from '../commonComponents/AxiosHelper';
import LoadingComponent from '../commonComponents/LoadingComponent';
import DropdownComponent from '../commonComponents/DropdownComponent';
import ErrorComponent from '../commonComponents/ErrorComponent';
import Form from '../commonComponents/Form.v2'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setUserList } from '../../../src/actions';

var formUpload = {
    "selectTemplate": {
        "name": "selectTemplate", "label": "Select Feature Restriction Template:", "type": "dropdown", "text_value": "", "options": [], requiredFlag: true
    },
    "customTemplateName": {
        "name": "customTemplateName", "label": "Custom Template Name:", "type": "hide", "text_value": "", requiredFlag: true
    },
    "customTemplateNav": {
        "name": "customTemplateNav", "label": "Select Application Navigation Features", "type": "hide", "options": [], multiple: true, requiredFlag: true
    },
    "customTemplateFeature": {
        "name": "customTemplateFeature", "label": "Select Application Features", "type": "hide", "options": [], multiple: true, requiredFlag: true
    }
}
class UserAccessComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            userData: null,
            toolInfo: null,
            userList: null,
            users:null,
            permissionDrop: {
                "0": { "name": "No Access", "value": "0" },
                "1": { "name": "Admin", "value": "1" },
                "3": { "name": "Read", "value": "3" }
            },
            row:[],
            columns:null,
            columnOptions:null,
            formVariables: null,
            restrictionTemplate: null,
            restrictionCustomFeatures: null,
            menuClickName: null,
            selectedUser:null,
        };

        this.headerData = {
            "name": { "name": "name", "label": "Name", "type": "text" },
            "metricUnit": { "name": "metricUnit", "label": "Metric Unit", "type": "dropdown" },
            "metricDisplay": { "name": "metricPrefix", "label": "Metric Display", "type": "dropdown" },
            "numberShorten": { "name": "numberShorten", "label": "Number Shorten", "type": "dropdown" },
            "numberRoundoff": { "name": "roundOff", "label": "Number Roundoff", "type": "number" },
        }

        this.bulkFormData = {
            // "metricPrefix": {
            //     "name": "metricPrefix", "label": "Metric Prefix", "type": "dropdown", "options": [
            //         { "name": "Select Option", "value": "3" }, ...Object.values(this.state.metricPrefix)
            //     ]
            // },
        }

        this.importFormData = {
            "fileImport": {
                "name": "fileImport", "label": "File Import", "type": "file"
            }
        }

        this.headerMapping = {
            "name": "Name",
            "isDerived": "Metric Type",
            "formula": "Formulae",
            "defaultFormula": "Aggregation Type",
            "isDisplay": "Display"
        }

        this.buttons = {
            "addButton": [{ "label": "Add", "type": "normal", "display": false, "action": "add" }],
            "dropdownConfig": [{
                "label": "More", "type": "dropdown", "display": true,
                "children": [
                    { "label": "Export CSV", "action": "export" },
                ]
            }],
            "editButton": [{ "class": "", "label": "Edit", "type": "normal", "display": true, "action": "edit" }],
            "saveButton": [{
                "class": "", "label": "Save", "type": "normal", "display": false, "action": "save"
            }],
            "cancelButton": [{ "class": "", "label": "Cancel", "type": "normal", "display": false, "action": "cancel" }],
            "loadingButton": [{ "id": "loadingButton", "type": "loading", "display": false, "action": "load" }]
        }
        this.change_handle = this.change_handle.bind(this);
        this.saveHandle = this.saveHandle.bind(this);
        this.change_table_format = this.change_table_format.bind(this);
        this.handleDataUpdate = this.handleDataUpdate.bind(this);
        this.fetchUserAccessData = this.fetchUserAccessData.bind(this);
        this.handleValueFormat = this.handleValueFormat.bind(this);
        this.submitHandle = this.submitHandle.bind(this);
        this.handleUserChange = this.handleUserChange.bind(this);
        this.handleUserDropdownFormat = this.handleUserDropdownFormat.bind(this);
        this.configRules = this.configRules.bind(this);
        this.fetchFilterValues = this.fetchFilterValues.bind(this);
        // this.fetchColumns = this.fetchColumns.bind(this);
        this.formatSelectedText = this.formatSelectedText.bind(this);
        // this.handleRules = this.handleRules.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.configFeatureRestriction = this.configFeatureRestriction.bind(this);
        this.handleDropDownValue = this.handleDropDownValue.bind(this);
    }

    componentWillMount() {
        let selectedUser = this.props?.location?.state?.data ? this.props?.location?.state?.data?.primaryEmail :  this.props.authData.username
        if (selectedUser != undefined) {
            this.fetchUserAccessData(false, null, selectedUser);
            this.setState({selectedUser:selectedUser})
        } else {
            this.fetchUserAccessData();
        }
    }


    componentDidMount() {
        jQuery(".custom-file-input").on("change", function () {
            var fileName = jQuery(this).val().split("\\").pop();
            jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        });
      
    }


    componentDidUpdate(prevProps, nextState) {
        if (prevProps.datasetValue !== this.props.datasetValue) {
            let that = this;
            this.fetchUserAccessData();
        }
    }



    fetchUserAccessData(refresh = false, index = null, selectedUser, getList = true) {
        let that = this;
        let encodedEmail = selectedUser ? encodePassword(selectedUser) : that.state.userData?.primaryEmail != undefined ? encodePassword(that.state.userData?.primaryEmail) :''
        that.setState({ users: null, userData: null });
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            companyName: this.props.authData.companyName,
            activeUsers: true,
            getList: getList,
            email:encodedEmail!=''? encodedEmail:undefined
            // toolId: this.props.datasetValue
        }
        CallAPI('get', '/app/userConfig/getUsers', null, params, 0, function (response) {
            if (response?.status == false) {
                checkIfMaintenanceModeOn(response)
            }
            let userState = that.props.location.state
            let userData = (that.props.location.state != null && that.props.location.state != undefined) ? that.props.location.state.data : response.users[0];
            if(that.props.location.state != null && that.props.location.state != undefined  ){
            that.setState({selectedUser:selectedUser})
            }
            that.props.history.replace({ ...history.location, state: null });
            // if(response.data !== undefined && response.data == "error"){
            //     userData = response.data;
            // }
            if (userState != null && userState != undefined) {
                Object.values(response.users).map(function (innerData) {
                    if (innerData.userId === userData.userId) {
                        userData = innerData
                    }
                })
            }
            if (refresh) {
                userData = response.users[index];
            }
            if (response && response.userList != null) {
                // that.setState({ users: response.users }); // Update the state only if the response is not empty
                that.props.setUserList({ usersList: response.userList })
            } else {
                that.props.setUserList({ usersList: response.users })
            }
            that.setState({
                users:response.users,
                userData: userData?userData:response.users?.[0],
                restrictionTemplate: response.rm_template,
                restrictionCustomFeatures: response.rm_custom_feature_list,
            })


        }, this.props.authData)
    }


    change_handle(data) {
        // let metric_obj = this.props.location.state.data.data;
        let metric_obj = this.state.userData?.data;
        let final_value = this.handleValueFormat(data.value);

        if (this.state[data.colDef.field]) {
            Object.values(this.state[data.colDef.field]).map(function (innerData) {
                if (innerData.name == data.value) {
                    final_value = innerData.value;
                }
            })
        }

        let field = data.colDef.field == "label" ? "value" : data.colDef.field;

        // metric_obj[data.rowIndex][field] = final_value;
        metric_obj[data.node.id][field] = final_value;
        // metric_obj[data.rowIndex]['rockmetric_update'] = true;
        metric_obj[data.node.id]['rockmetric_update'] = true;
        if (metric_obj[data.node.id]['rockmetric_update_columns'] == undefined) {
            metric_obj[data.node.id]['rockmetric_update_columns'] = []
        }
        metric_obj[data.node.id]['rockmetric_update_columns'].push(field);
    }

    // handleRules(e,reference){
    //     let column_rules = [];
    //     let current_rules = null;
    //     let filter_values = jQuery(`#${e.target.id}`).val();
    //     if (e.target.id == "columnField"){
    //         column_rules = filter_values.toString();
    //         current_rules = this.state.columns;
    //         current_rules = column_rules;
    //         this.setState({
    //             columns: current_rules
    //         })
    //     }
    // }

    saveHandle(value) {
        let that = this, checkValidity = true;
        let index = parseInt(this.state.toolInfo.rowId, 10);
        let checkForFilters = gridOptions.api.getFilterModel();
        let userFilterData = this.state.userData;
        if (userFilterData['data'][index]['rockmetric_update_columns'] == undefined) {
            userFilterData['data'][index]['rockmetric_update_columns'] = []
        }
        if (value === "updateModal") {
            let savedFilter = null;
            if (Array.isArray(this.state.row)) {
                savedFilter = this.state.row;
            }
            // let savedFilter = this.state.row ? userFilterData['data'][index]['filter'] : this.state.row;
            // if(savedFilter == null){
            //     savedFilter = '';
            // }
            // let columnFields = this.formatSelectedText(jQuery("#columnField :selected"));
            let arrayToSubmit = this.state.columns !== null ? [...this.state.columns] : this.state.columns;
            if (this.state.row !== 0) {
                userFilterData['data'][index]['filter'] = JSON.stringify(savedFilter);
                userFilterData['data'][index]['rockmetric_update_columns'].push('filter');

            }

            // if (this.state.columns){
            userFilterData['data'][index]['restrictedFields'] = JSON.stringify(arrayToSubmit);
            userFilterData['data'][index]['rockmetric_update_columns'].push('restrictedFields');
            // }
            jQuery("#updateModal").modal('toggle');
            this.setState({
                userData: userFilterData
            });
            setTimeout(() => {
                gridOptions.api.setFilterModel(checkForFilters);
            }, 1000);
        } else if (value === "featureRestrictionModal") {
            $('#featureRestrictionForm').serializeArray().map((innerData) => {
                if (checkValidity) {
                    if (innerData.name === "selectTemplate") {
                        let templateName = {};
                        if (innerData.value !== "custom") {
                            templateName = this.state.restrictionTemplate.find(el => el.id === innerData.value);
                        }
                        if (innerData.value === "custom" || templateName.template_value.includes("_custom")) {
                            userFilterData['data'][index]['feature_template_id'] = {
                                "custom": {
                                    'dash_nav': [],
                                    'dash_feature': [],
                                }
                            };
                        } else {
                            templateName = this.state.restrictionTemplate.find(el => el.id === innerData.value);
                            userFilterData['data'][index]['custom_template_name'] ? delete userFilterData['data'][index]['custom_template_name'] : null;
                            userFilterData['data'][index]['feature_template_id'] = {}
                            userFilterData['data'][index]['feature_template_id'][`${templateName.template_name}`] = innerData.value;
                        };
                    } else if (innerData.name === "customTemplateNav") {
                        userFilterData['data'][index]['feature_template_id']['custom']['dash_nav'].push(innerData.value);
                    } else if (innerData.name === "customTemplateFeature") {
                        userFilterData['data'][index]['feature_template_id']['custom']['dash_feature'].push(innerData.value);
                    } else if (innerData.name === "customTemplateName") {
                        checkValidity = checkSpecialChars(innerData.value) ? false : true
                        checkValidity ? userFilterData['data'][index]['custom_template_name'] = innerData.value.trim() : null;
                    }
                }
            })
            if (checkValidity === false) {
                alert('Please enter valid input for Custom Template Name!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
            } else {
                if (Object.keys(userFilterData['data'][index]['feature_template_id'])[0] === "custom") {
                    JSON.stringify(userFilterData['data'][index].feature_template_id.custom);
                }
                userFilterData['data'][index]['rockmetric_update_columns'].push('feature_template_id');
                jQuery("#featureRestrictionModal").modal('toggle');
                document.getElementById('editButton').click();
                this.setState({
                    userData: userFilterData
                });
                setTimeout(() => {
                    gridOptions.api.setFilterModel(checkForFilters);
                }, 1000);
            }
        }
    }

    submitHandle() {
        let that = this;
        let userData = that.state.userData;
        let index = that.props.allUserList.findIndex((inner, i) => {
            return userData.primaryEmail == inner?.email || inner?.primaryEmail;
        });
        let filteredData = userData?.data.filter((element, i) => {
            return  (element['rockmetric_update_columns'] && element['rockmetric_update_columns'].length !== 0) 
                // return element;
        })
        // let innerArray = { 'userId': userData.userId, 'emailAddress': userData.primaryEmail, 'siteId': userData.siteId }
        let final_data = filteredData.map((innerData, j) => {
            let innerArray = {};
            innerArray['toolId'] = innerData['toolId'];
            innerArray['userId'] = userData['userId'];
            innerArray['userType'] = innerData['userType'];
            innerArray['filter'] = innerData['filter'];
            innerArray['email_dataset_name'] = innerData['email_dataset_name'];
            innerArray['toolName'] = innerData['name'];
            innerArray['mailSent'] = innerData['mailSent'];
            innerArray['emailAddress'] = userData['primaryEmail'];
            innerArray['siteId'] = userData['siteId'];
            innerArray['restrictedFields'] = innerData['restrictedFields'];
            if (innerData['custom_template_name']) {
                innerArray['custom_template_name'] = innerData['custom_template_name']
                innerArray['company_name'] = this.props.authData.companyName;
            }
            innerArray['feature_template_id'] = innerData['feature_template_id']
            innerArray['rockmetric_update_columns'] = innerData['rockmetric_update_columns'];
            //innerArray['rockmetric_update'] = "true";
            return innerArray;
        });
        let params = {
            // userId: this.props.authData ? this.props.authData.userId : null,
            // siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
        }
        let postData = { "data": final_data }
        isAdHocDataLoading(true)
        CallAPI('POST', '/app/userConfig/updateUser', postData, params, 0, function (response) {
            if (response['status']) {
                alert("Successfully updated");
                isDataLoading(false)
                that.fetchUserAccessData(true, index);
            }
            else {
                alert("Error while updating permissions");
                that.fetchUserAccessData();
            }
        }, this.props.authData)
    }

    change_table_format(array_data) {
        try {
            var that = this;
            let temp_array = [];
            if(array_data!=null){
            array_data.data.map(function (innerData, index) {
                let inner_temp_array = [];
                inner_temp_array.label = innerData.name;
                inner_temp_array.toolId = innerData.toolId;
                inner_temp_array.userId = array_data.userId;
                inner_temp_array.rights = (innerData.filter == "" || innerData.filter == null || innerData.filter == "null") ? '-' : that.formatSelectedText(JSON.parse(innerData.filter));
                inner_temp_array.filter = (innerData.filter == "" || innerData.filter == null) ? '-' : JSON.parse(innerData.filter);
                inner_temp_array.restrictedFieldsArray = (innerData.restrictedFields == "" || innerData.restrictedFields == null) ? '-' : JSON.parse(innerData.restrictedFields);
                inner_temp_array.restrictedFields = (innerData.restrictedFields == "" || innerData.restrictedFields == null || innerData.restrictedFields == "null") ? '-' : that.formatSelectedText(JSON.parse(innerData.restrictedFields));
                inner_temp_array.userType = innerData.userType ? that.state.permissionDrop[innerData.userType].name : that.state.permissionDrop["0"].name;

                let tempObj = {};
                if (typeof innerData.feature_template_id !== "object") {
                    tempObj = that.state.restrictionTemplate.find(el => el.id === innerData.feature_template_id);
                } else tempObj = that.state.restrictionTemplate.find(el => el.id === Object.values(innerData.feature_template_id)[0]);
                // else tempObj['template_type'] = "0";
                if (innerData.custom_template_name || tempObj.template_type === "1") {
                    if (innerData.custom_template_name !== undefined) {
                        inner_temp_array.featureTemplate = `${innerData.custom_template_name} (Custom)`;
                    } else if (tempObj.template_type === "1") {
                        inner_temp_array.featureTemplate = `${tempObj.template_name} (Custom)`;
                    }
                } else {
                    let templateName = null;
                    if (typeof innerData.feature_template_id === "object") {
                        templateName = Object.keys(innerData.feature_template_id)[0];
                    } else {
                        let tempVar = that.state.restrictionTemplate.find(el => el.id === innerData.feature_template_id);
                        templateName = tempVar.template_name;
                    }
                    inner_temp_array.featureTemplate = templateName;
                }

                inner_temp_array.featureTemplateId = (innerData.feature_template_id == "" || innerData.feature_template_id == undefined || innerData.feature_template_id == null) ? '-' : innerData.feature_template_id;
                temp_array.push(inner_temp_array);
            })
            return { data: temp_array };
        }  
        else{
            return {data:{data:[]}}
        }
        } catch (e) {
            return "error";
        }

    }

    handleValueFormat(text) {
        let filteredValue = Object.values(this.state.permissionDrop).filter((element, i) => {
            return text == element.name;
        })
        return filteredValue[0]['value'];
    }


    handleDataUpdate(data) {
        let columns = this.state.columns;
        columns.metric = data;
        this.setState({
            columns: columns
        })
    }

    handleUserChange(e, reference) {
        let email = e.target.value
        let userChange = true
        this.fetchUserAccessData(false, null, email, userChange)
    }

    handleUserDropdownFormat(data) {
        let userList = data
        if (userList != null || userList != undefined) {

            let formattedData = userList.map((element, i) => {
                let innerArray = {};
                innerArray['name'] =
                    `${element.firstname != undefined ? element.firstname : element.firstName} ${element.lastname != undefined ? element.lastname : element.lastName}`
                innerArray['value'] = element.email != undefined ? element.email : element.primaryEmail;
                return innerArray;
            });
            return formattedData;
        }
    }

    fetchFilterValues = (params, callback)=>{
        const siteId = localStorage.Dataset ?JSON.parse(localStorage.Dataset).siteId : null;
        const toolId = this.state.toolInfo.toolId;
        const url = `/app/searchElastic?siteId=${siteId}&toolId=${toolId}&pattern=${params}&type=2&value=&exclude=`;

        CallAPI('GET', url, null, params, 0, function (response) {
            callback(response);
        },this.props.authData)
    }

    handleInputChange(value,reference){
        let columnFilters = gridOptions.api.getFilterModel();
        let current_rules = value;
        if (reference.name == "rowRules"){       
            if(current_rules !== null && reference.action !== "clear"){
            this.setState({
                row: current_rules
            })
            } else {
                this.setState({
                    row: null
                })
            }
        } else if (reference.name == "columnRules"){
            if(current_rules !== null && reference.action !== "clear"){
                current_rules = value;
            } else {
                current_rules = null;
            }
            this.setState({
                columns: current_rules
            })
        }
        setTimeout(() => {
            gridOptions.api.setFilterModel(columnFilters);
        }, 1000);
    }

    // fetchColumns(params, callback) {
    //     let filterAsyncParams = {
    //         siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
    //         toolId: this.state.toolInfo.toolId,
    //         userId: this.props.authData ? this.props.authData.userId : null
    //     };
    //     CallAPI('GET', '/app/getColumns', null, filterAsyncParams, 0, function (response) {
    //         callback(response);
    //     },this.props.authData)

    // }

    configRules() {
        const that = this;
        jQuery("#updateModal").modal('show');
        let selectedDataset = gridOptions.api.getSelectedNodes()[0]['data'];
        selectedDataset['rowId'] = gridOptions.api.getSelectedNodes()[0]['id'];
        let columnFilters = gridOptions.api.getFilterModel();
        const defaultRowRulesValues = selectedDataset.filter == "-" ? null : selectedDataset.filter;

        const defaultRestrictedFields = selectedDataset.restrictedFields == "-" ? null : selectedDataset.restrictedFieldsArray;

        let filterAsyncParams = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: selectedDataset.toolId,
            // userId: this.props.authData ? this.props.authData.userId : null
        };
        CallAPI('GET', '/app/getColumns', null, filterAsyncParams, 0, function (response) {
            // callback(response);
            that.setState({
                toolInfo: selectedDataset,
                row:defaultRowRulesValues,
                columns: defaultRestrictedFields,
                columnOptions:response,
                menuClickName: "updateRules",
             })
        },this.props.authData)
        setTimeout(() => {
            gridOptions.api.setFilterModel(columnFilters);
        }, 1000);
    }
    configFeatureRestriction = () => {
        let selectedDataset = gridOptions.api.getSelectedNodes()[0]['data'];
        selectedDataset['rowId'] = gridOptions.api.getSelectedNodes()[0]['id'];
        let columnFilters = gridOptions.api.getFilterModel();
        let tempForm = JSON.parse(JSON.stringify(formUpload));
        let templateOptions = [
            { "name": "Select Feature Restriction Template", "value": ""},
            { "name": "Create Custom Template", "value": "custom"},
        ];
        let dashNavOptions = [];
        let dashFeatureOptions = [];
        this.state.restrictionTemplate.forEach(singleObj => {
            if (singleObj.template_type === "1") {
                templateOptions.push({ "name": `${singleObj.template_name} (Custom)`, "value": `${singleObj.id}`});    
            }
            else templateOptions.push({ "name": `${singleObj.template_name}`, "value": `${singleObj.id}`});
        })
        this.state.restrictionCustomFeatures.forEach(singleElement => {
            if (singleElement.availability === "dash_nav") {
                dashNavOptions.push({ "name": `${singleElement.featureName}`, "value": `${singleElement.category}`});
            } else if (singleElement.availability === "dash_feature") {
                dashFeatureOptions.push({ "name": `${singleElement.featureName}`, "value": `${singleElement.category}`});
            }
        });
        tempForm['selectTemplate']['options'] = templateOptions;
        tempForm['customTemplateNav']['options'] = dashNavOptions;
        tempForm['customTemplateFeature']['options'] = dashFeatureOptions;
        if (selectedDataset.featureTemplate !== "-" || selectedDataset.featureTemplateId !== "-") {
            if (typeof selectedDataset.featureTemplateId === "string" && selectedDataset.featureTemplate.includes("(Custom)") === true) {
                tempForm['selectTemplate']['text_value'] = selectedDataset.featureTemplateId
                tempForm['customTemplateName']['type'] = "text";
                let finalTemplateName = selectedDataset.featureTemplate.split("(")[0].trim();
                tempForm['customTemplateName']['text_value'] = finalTemplateName;
                tempForm['customTemplateNav']['type'] = "dropdown";
                let tempVar = this.state.restrictionTemplate.find(el => el.id === selectedDataset.featureTemplateId);
                tempForm['customTemplateNav']['text_value'] = JSON.parse(tempVar.feature_list).dash_nav;
                tempForm['customTemplateFeature']['type'] = "dropdown";
                tempForm['customTemplateFeature']['text_value'] = JSON.parse(tempVar.feature_list).dash_feature;
            } else if (typeof selectedDataset.featureTemplateId === "object" && Object.keys(selectedDataset.featureTemplateId)[0] === "custom") {
                tempForm['selectTemplate']['text_value'] = "custom";
                tempForm['customTemplateName']['type'] = "text";
                let finalTemplateName = selectedDataset.featureTemplate.split("(")[0].trim();
                tempForm['customTemplateName']['text_value'] = finalTemplateName;
                tempForm['customTemplateNav']['type'] = "dropdown";
                tempForm['customTemplateNav']['text_value'] = selectedDataset.featureTemplateId.custom.dash_nav;
                tempForm['customTemplateFeature']['type'] = "dropdown";
                tempForm['customTemplateFeature']['text_value'] = selectedDataset.featureTemplateId.custom.dash_feature;
            } else if (typeof selectedDataset.featureTemplateId === "string" && selectedDataset.featureTemplate.includes("(Custom)") === false) {
                tempForm['selectTemplate']['text_value'] = selectedDataset.featureTemplateId;
            } else {
                tempForm['selectTemplate']['text_value'] = Object.values(selectedDataset.featureTemplateId)[0];
            }
        }
        this.setState({
            toolInfo: selectedDataset,
            formVariables: tempForm,
            menuClickName: "featureRestriction",
        })
        setTimeout(() => {
            jQuery('#featureRestrictionModal').modal('show');
        }, 100);
        gridOptions.api.setFilterModel(columnFilters);
    }
    handleDropDownValue = (e) => {
        e.preventDefault();
        let checkForFilters = gridOptions.api.getFilterModel();
        if (e.target.name !== "customTemplateNav" && e.target.name !== "customTemplateFeature") {
            let tempForm = { ...this.state.formVariables };
            tempForm[e.target.name]['text_value'] = e.target.value;
            if (e.target.name === "selectTemplate") {
                if (e.target.value === "custom" || e.target.options[e.target.selectedIndex].textContent.includes("(Custom)")) {
                    tempForm['customTemplateName']['type'] = "text";
                    tempForm['customTemplateName']['text_value'] = '';
                    tempForm['customTemplateNav']['type'] = "dropdown";
                    tempForm['customTemplateNav']['text_value'] = []
                    tempForm['customTemplateFeature']['type'] = "dropdown";
                    tempForm['customTemplateFeature']['text_value'] = []
                    if (e.target.options[e.target.selectedIndex].textContent.includes("(Custom)")) {
                        let finalTemplateName = e.target.options[e.target.selectedIndex].textContent.split("(")[0].trim();
                        tempForm['customTemplateName']['text_value'] = finalTemplateName;
                        let tempVar = this.state.restrictionTemplate.find(el => el.id === e.target.value);
                        tempForm['customTemplateNav']['text_value'] = JSON.parse(tempVar.feature_list).dash_nav;
                        tempForm['customTemplateFeature']['text_value'] = JSON.parse(tempVar.feature_list).dash_feature;
                    }
                } else {
                    tempForm['customTemplateName']['type'] = tempForm['customTemplateName']['type'] === "text" ? "hide" : "hide";
                    tempForm['customTemplateName']['text_value'] = '';
                    tempForm['customTemplateNav']['type'] = tempForm['customTemplateNav']['type'] === "dropdown" ? "hide" : "hide";
                    tempForm['customTemplateNav']['text_value'] = []
                    tempForm['customTemplateFeature']['type'] = tempForm['customTemplateFeature']['type'] === "dropdown" ? "hide" : "hide";
                    tempForm['customTemplateFeature']['text_value'] = []
                }
            }
            this.setState({
                formVariables: tempForm,
            })
        }
        setTimeout(() => {
            gridOptions.api.setFilterModel(checkForFilters);
        }, 1000);
    }

    formatSelectedText(selectedObj) {
        let text = selectedObj.map((element,i) => {
            // return jQuery(element).text(); .get().join(',');
            return element.label;
        }).toString();
        return text.replace(/(^,)|(,$)/g, '');
    }


    render() {

        let that = this;
        let userAccessData = this.state.userData;
        var mainData = <LoadingComponent/>
        // listens for the event when modal is closed and resets the title and button for #updateModal Modal
        jQuery('#updateModal').on('hidden.bs.modal', function (e) {
            if (that.state.toolInfo !== null) {
                that.setState({
                    toolInfo: null,
                    row:null,
                    columns:null
                })
            }
        });
        
        // if (this.state.userData) {
            let final_data = this.change_table_format(userAccessData?userAccessData:null);

            if(final_data !== "error"){
                let accessLevelArray = Object.values(this.state.permissionDrop).map(function (value) {
                    return value.name;
                });

                var columns_array = [
                    { label: "Access Level", value: "userType", type: "html", dropdown_value: accessLevelArray, editable: true, hide: false, dataType: 'string' },
                    { label: "Row Rules", value: "rights", type: "text", editable: false, hide: false, dataType: 'string' },
                    { label: "Column Rules", value: "restrictedFields", type: "text", editable: false, hide: false, dataType: 'string' },
                    { label: "Feature Restriction Template", value: "featureTemplate", type: "text", editable: false, hide: false, dataType: 'string' },
                ];

                var firstColumn = "Dataset";


                var updateModalBody = null;
                var featureRestrictionModalBody = null;

                if (this.state.toolInfo !== null) {
                    let columnFieldsValue = null;

                    let rowValue = null;

                    if(this.state.row !== null){
                        rowValue = this.state.row.length !== 0 ? this.state.row : null;
                    }
   

                    const columnValue = this.state.columns !== null ? this.state.columns : null;

                    if (columnValue !== null && columnValue !== undefined){
                        if (Array.isArray(columnValue)) { 
                            columnFieldsValue = columnValue;  
                        } 
                    }

                    updateModalBody = (that.state.menuClickName === "updateRules"
                        ? <div>
                            <div className="form-group" id="filter_dropdown">
                                <label className="mg-l-10" htmlFor={`filter_row`}>Select Row Rules</label>
                                <AsyncSelect
                                    name="rowRules"
                                    ref="rowRules"
                                    cacheOptions
                                    loadOptions={that.fetchFilterValues}
                                    defaultOptions={true}
                                    value={rowValue}
                                    onChange={that.handleInputChange}
                                    isMulti={true}
                                />
                                {/* <DropdownComponent key="filter_dropdown" id="filter_row" multi={true} value={[]} async={true} asyncHandle={this.fetchFilterValues} label='label' asyncParams={filterAsyncParams} onChange={this.handleRules} /> */}
                            </div>
                            <div className="form-group" id="column_dropdown">
                                <label className="mg-l-10" htmlFor={`columnField`}>Select Column Rules to Restrict</label>
                                <Select
                                    name="columnRules"
                                    ref="columnRules"
                                    options={that.state.columnOptions}
                                    defaultValue={columnFieldsValue}
                                    onChange={that.handleInputChange}
                                    isMulti={true}
                                />
                                {/* <AsyncSelect
                                name="columnRules"
                                ref="columnRules"
                                cacheOptions
                                loadOptions={that.fetchColumns}
                                defaultOptions={true}
                                value={columnFieldsValue}
                                onChange={that.handleInputChange}
                                isMulti={true}
                            /> */}
                                {/* <DropdownComponent key="column_dropdown" id="columnField" multi={true} value={columnFieldsValue} async={true} asyncHandle={this.fetchColumns} optionValue='columnName' label='label' asyncParams={filterAsyncParams} value={[]} dropdownData={[]} onChange={this.handleRules} />  */}
                            </div>
                        </div>
                        : null);
                }
                let selectedValues = {}
                if (this.state.restrictionTemplate && this.state.restrictionTemplate !== null && this.state.formVariables && this.state.formVariables !== null) {
                    if (this.state.formVariables.customTemplateName.text_value && this.state.formVariables.customTemplateName.text_value !== '') {
                        selectedValues = this.state.restrictionTemplate.find(el => el.template_name === this.state.formVariables.customTemplateName.text_value);
                    } else if (this.state.formVariables.customTemplateName.type === 'hide' && this.state.formVariables.selectTemplate.text_value !== '') {
                        selectedValues = this.state.restrictionTemplate.find(el => el.id === this.state.formVariables.selectTemplate.text_value);
                    } else {
                        selectedValues = null;
                    }
                }
                featureRestrictionModalBody = this.state.formVariables !== null && Object.keys(this.state.formVariables).length > 0 
                    ? <>
                        <div className="alert alert-primary">
                            {/* <h5 className="alert-heading tx-semibold">{`Template Name: ${selectedValues !== undefined && selectedValues !== null ? selectedValues.template_name : "Custom Name"}`}</h5> */}
                            <p className="alert-heading">
                                <span className="tx-semibold">TEMPLATE NAME:</span>{` ${selectedValues !== undefined && selectedValues !== null ? selectedValues.template_name : "Custom Name"}`}
                            </p>
                            <hr></hr>
                            <p className="mg-b-10">
                                <span className="tx-semibold">NAVIGATION:</span>{` ${selectedValues !== undefined && selectedValues !== null ? JSON.parse(selectedValues.feature_list).dash_nav.join(", ") : "Not Set"}`}
                            </p>
                            <p className="mg-b-0">
                                <span className="tx-semibold">FEATURES:</span>{` ${selectedValues !== undefined && selectedValues !== null ? JSON.parse(selectedValues.feature_list).dash_feature.join(", ") : "Not Set"}`}
                            </p>
                        </div>
                        <Form label_array={this.state.formVariables} handle_form_drop_down={this.handleDropDownValue} />
                    </>
                    : null;

                var modals = {
                    "updateModal": {
                        "form_name": "update_form", "id": "update_rules", "title": "Enable Data Security ", "body": updateModalBody, "button_name": "Update", "action": "update", "display": true, "formKey": `update_form_${Math.floor(Math.random() * 10)}`
                    },
                    "featureRestrictionModal": {
                        "id": "featureRestrictionModal", "form_name": "featureRestrictionForm", "form_id": "featureRestrictionForm", "title": "Set Feature Restriction", "body": featureRestrictionModalBody, "button_name": "Update", buttonType: "button", "display": true, "formKey": `featureRestriction_form_${Math.floor(Math.random() * 10)}`
                    }
                };

                var customMenu = {
                    "updateRules": {
                        "name": "updateRules", "label": "Update Rules", "action": this.configRules,
                    },
                    "featureRestrictionTemplate": {
                        "name": "featureRestrictionTemplate", "label": "Add Feature Restriction", "action": this.configFeatureRestriction,
                    }
                }
                let userOptions = that.props.allUserList?.length>0?that.props.allUserList:that.state.userList
                let userList = that.handleUserDropdownFormat(userOptions);
                let value = (that.props.location.state !== null && that.props.location.state !== undefined) ? that.props.location.state.data.primaryEmail : that.state.selectedUser;

                mainData = <>
                    <div className="wd-300">
                        <DropdownComponent class="col-md-3 pd-0" name="userDropdown" id="userList" value={value} dropdownData={userList} onChange={this.handleUserChange} />
                    </div>
                    <TableParent
                        ref="userAccess"
                        data={final_data}
                        parentConfig={this.state}
                        columns_array={columns_array}
                        firstColumn={firstColumn}
                        editData={this.state.userData}
                        modalConfig={modals}
                        onCellChange={this.change_handle}
                        filename="User Permission List"
                        // actionArray={this.props.menuData}
                        menuAction={this.handleMenuAction}
                        handleDataUpdate={this.handleDataUpdate}
                        submitHandle={this.submitHandle}
                        buttonConfig={this.buttons}
                        customMenu={customMenu}
                        rowSelection="single"
                        updateModalAction={this.saveHandle}
                    />
                    {/* <ModalComponent modalConfig={modals['updateModal']} action={this.handleUserAccess} /> */}
                </>
            }
            else {
                mainData = <ErrorComponent />;
            }
        // }
        

        return (
            <div>
                {mainData}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        allUserList: state.dataSet.usersList, 
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setUserList
    }, dispatch)
}

// export default DatasetComponent;
export default connect(mapStateToProps, mapDispatchToProps)(UserAccessComponent);